import PropTypes from 'prop-types'
import classNames from 'classnames'
import Link from 'next/link'

import generateRoute from 'helpers/generateRoute'

import s from './Link.module.css'

function LinkInternal({
                        href: initialHref = '',
                        label = null,
                        children = null,
                        className = '',
                        type = null,
                        site = null,
                      }) {

  const { href, as } = generateRoute({ type, slug: initialHref })

  return (
    <Link href={href} as={as} className={classNames(s.container, className)}>
      {children || label}
    </Link>
  )
}

LinkInternal.propTypes = {
  href: PropTypes.string,
  as: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
}

export default LinkInternal
